import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Rating,
  Select,
  TextField,
  Typography,
  styled,
} from '@mui/material';
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {COLORS} from 'shared/constants/AppEnums';
import {grey} from '@mui/material/colors';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import {onGetDepartmentAutoComplete} from 'redux/actions/admintools/Department';
import PropTypes from 'prop-types';
import Addressbook from 'shared/components/Addressbook/Addressbook';
import useModal from 'shared/hooks/useModal';
import UploadAksi from '../Component/UploadAksi';
import {useDropzone} from 'react-dropzone';
import {
  FETCH_ERROR,
  SET_AKSI_PERUBAHAN_FILE,
} from 'shared/constants/ActionTypes';
import FileRow from '../Component/FileRow';
import {onGetTitleOptions} from 'redux/actions/admintools/Title';

const ErrorText = styled('div')({
  color: '#800000',
  fontSize: '0.875rem',
  marginLeft: '7px',
  marginTop: '4px',
});

const DialogForm = forwardRef((props, ref) => {
  const {optionsTitle} = useSelector((state) => state.jabatan);
  const {detail} = useSelector((state) => state.aksiPerubahan);
  const [isFileExistError, setIsFileExistError] = useState(false);

  const [config, setConfig] = useState({});
  const dispatch = useDispatch();
  const {stateAddress, toggleShow, toggleHide, setPayloadOnHide} = useModal();
  const [titleOptions, setTitleOptions] = useState(null);
  const [optionYear, setOptionYear] = useState(null);
  const [pelatihanOption, setPelatihanOption] = useState(null);
  const [pelatihan, setPelatihan] = useState('');
  const [year, setYear] = useState('');

  useEffect(() => {
    console.log(stateAddress, config);
    if (!stateAddress.isClose && !stateAddress.show) {
      if (config.judul === 'Name') {
        let member = [...stateAddress.payload];
        if (member.length > 0) {
          formik.setFieldValue('display_name', member[0].text);
          formik.setFieldValue('profile_nip', member[0].oriItem.nip);
          formik.setFieldValue(
            'unker',
            member[0].oriItem.structure.organizations.divisions.name,
          );
          formik.setFieldValue(
            'satker',
            member[0].oriItem.structure.organizations.divisions.departments
              .satker_name,
          );
        }
        console.log(member);
      }
      if (config.judul === 'Coach') {
        let member = [...stateAddress.payload];
        if (member.length > 0) {
          formik.setFieldValue('display_coach', member[0].text);
          formik.setFieldValue('coach_nip', member[0].oriItem.nip);
        }
      }
    }
  }, [stateAddress, config]);

  useEffect(() => {
    if (titleOptions) {
      if (detail && props.role !== 'add') {
        const index = optionsTitle.results.findIndex(
          (item) => item.name === detail.title,
        );
        if (index > -1)
          formik.setFieldValue('title_id', optionsTitle.results[index].id);
        else formik.setFieldValue('title_id', '');
      }
    }
  }, [titleOptions]);

  const handleToggleAddressBook = (title) => {
    let payloadPilihan = [];
    setConfig((config) => ({
      ...config,
      isTransform: true,
      judul: title,
      tabs: {
        jabatan: false,
        pegawai: true,
        personal: false,
        klasifikasi: false,
      },
      multiselect: false,
      payloadPilihan: payloadPilihan,
    }));

    toggleShow();
  };

  useEffect(() => {
    if (detail && props.role !== 'add') {
      formik.setFieldValue('display_name', detail.display_name);
      formik.setFieldValue('file', detail.file);
      formik.setFieldValue('satker', detail.satker);
      formik.setFieldValue('unker', detail.unker);
      formik.setFieldValue('profile_nip', detail.nip);
      formik.setFieldValue('benefit', detail.benefit);
      formik.setFieldValue('rating', detail.rating);
      formik.setFieldValue('implementation', detail.implementation);
      formik.setFieldValue('order', detail.order);
      formik.setFieldValue('coach_nip', detail.coach_nip);
      formik.setFieldValue('note', detail.note);
      formik.setFieldValue('display_coach', detail.coach);

      if (titleOptions) {
        if (detail && props.role !== 'add') {
          let idx = pelatihanOption.findIndex((x) =>
            x.name.includes(detail.title.split('ANGKATAN')[0].slice(0, -1)),
          );
          if (idx > -1) {
            setPelatihan(pelatihanOption[idx].name);
            setYear(detail.year);
          }

          const index = optionsTitle.results.findIndex(
            (item) => item.name === detail.title,
          );
          if(index > -1)
          formik.setFieldValue('title_id', optionsTitle.results[index].id);
        else  formik.setFieldValue('title_id', '');
        }
      }
    }
  }, [detail]);

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length !== 0 && acceptedFiles.length === 0) {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Tipe File Tidak Mendukung',
      });
    } else {
      props.setUploadedFiles(null);
      const size = (acceptedFiles[0].size / 1024 / 1024).toFixed(3);
      if (size <= 50) {
        // dispatch(onAddAttachmentDigisign('onDrop', acceptedFiles[0]))
        props.setUploadedFiles({
          name: acceptedFiles[0].name,
          type: acceptedFiles[0].type,
          size: acceptedFiles[0].size,
          file: acceptedFiles[0],
        });
        console.log(acceptedFiles[0]);
      } else {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Ukuran File Maksimal 50 MB',
        });
      }
    }
  }, []);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'application/': ['.pdf'],
    },
  });

  useEffect(() => {
    if (optionsTitle) {
      if (props.role === 'add') {
        let filteredTitle = optionsTitle.results.filter(
          (x) =>
            x.year === new Date().getFullYear() || new Date().getFullYear() - 1,
        );
        setTitleOptions(filteredTitle);
      } else setTitleOptions(optionsTitle.results);

      setPelatihanOption([
        {
          id: 1,
          name: 'LATIHAN DASAR',
        },
        {
          id: 2,
          name: 'PELATIHAN KEPEMIMPINAN PENGAWAS',
        },
        {
          id: 3,
          name: 'PELATIHAN KEPEMIMPINAN ADMINISTRATOR',
        },
        {
          id: 4,
          name: 'PELATIHAN KEPEMIMPINAN NASIONAL TINGKAT I',
        },
        {
          id: 5,
          name: 'PELATIHAN KEPEMIMPINAN NASIONAL TINGKAT II',
        },
      ]);

      setOptionYear([
        {id: 1, name: new Date().getFullYear() - 1},
        {id: 2, name: new Date().getFullYear()},
      ]);
    }
  }, [optionsTitle]);

  const validationSchema = Yup.object({
    display_name: Yup.string().required('Kolom Ini Wajib Diisi!'),
    display_coach: Yup.string().nullable(),

    profile_nip: Yup.string().required('Kolom Ini Wajib Diisi!'),
    coach_nip: Yup.string().nullable(),
    note: Yup.string().nullable(),
    rating: Yup.string().nullable(),
    benefit: Yup.string().nullable(),

    title_id: Yup.string().required('Kolom Ini Wajib Diisi!'),
    satker: Yup.string(),
    unker: Yup.string(),
    order: Yup.string().nullable(),
    implementation: Yup.string().nullable(),
  });
  const formik = useFormik({
    initialValues: {
      title_id: '',
      satker: '',
      profile_nip: '',
      display_name: '',
      display_coach: '',
      benefit: '',
      rating: '',
      unker: '',
      order: '',
      coach_nip: '',
      note: '',

      implementation: '',
      file: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  //   const handleChangeInput = (e) => {
  //     const {id, value} = e.target;

  //     setDataOrganization({
  //       ...dataOrganization,
  //       [id]: value,
  //     });
  //   };

  const handleBlur = (event) => {
    formik.setFieldValue('satker_name', event.target.value);
  };

  const handleChangePelatihan = (event) => {
    setPelatihan(event.target.value);
  };

  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };

  useEffect(() => {
    if (year !== '') {
      formik.setFieldValue('title_id', '');
      dispatch(onGetTitleOptions(pelatihan, year));
    }
  }, [year, pelatihan]);

  const handleChangeOrder = (event) => {
    const {value} = event.target;
    // Ensure the value is within the specified range
    const parsedValue = Math.max(1, Math.min(3, parseInt(value)));

    formik.setFieldValue('order', parsedValue);
  };

  const onDeleteUploadFile = (file) => {
    formik.setFieldValue('file', '');

    props.setUploadedFiles(null);
  };

  useImperativeHandle(ref, () => ({
    returnForm() {
      setIsFileExistError(true);
      Object.keys(formik.values).forEach((fieldName) => {
        formik.setFieldTouched(fieldName, true);
      });
      return formik;
    },
    resetForm() {
      formik.resetForm();
      setIsFileExistError(false);
    },
  }));

  return (
    <>
      <form>
        <Box
          padding={'10px'}
          maxHeight={'335px'}
          overflow={'auto'}
          sx={{
            '& label.Mui-focused': {
              color: COLORS.primary,
            },
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: grey[500],
              },
              '&.Mui-focused fieldset': {
                borderColor: COLORS.primary,
                color: COLORS.primary,
              },
            },
          }}
        >
          <Grid container columnSpacing={4} rowSpacing={3}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id='demo-simple-select-label'>
                  Nama Kategori
                </InputLabel>
                <Select
                  required
                  labelId='demo-simple-select-label'
                  id='pelatihan'
                  name='pelatihan'
                  disabled={props.role === 'detail' ? true : false}
                  onChange={handleChangePelatihan}
                  value={pelatihan}
                  label='Nama Kategori'
                >
                  {pelatihanOption
                    ? pelatihanOption.map((item, key) => {
                        return (
                          <MenuItem key={item.id} value={item.name}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : ''}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl sx={{width: '100%'}}>
                <InputLabel id='demo-simple-select-label'>Tahun</InputLabel>
                <Select
                  required
                  defaultValue=''
                  fullWidth
                  disabled={props.role === 'detail' ? true : false}
                  labelId='demo-simple-select-label'
                  id='year'
                  name='year'
                  onChange={handleChangeYear}
                  value={year}
                  label='Tahun'
                >
                  {optionYear
                    ? optionYear.map((item, key) => {
                        return (
                          <MenuItem key={item.id} value={item.name}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : ''}
                </Select>
              </FormControl>
            </Grid>

            {year && pelatihan && (
              <>
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth>
                    <InputLabel id='demo-simple-select-label'>
                      Pilihan Jenis Kategori
                    </InputLabel>
                    <Select
                      required
                      defaultValue=''
                      labelId='demo-simple-select-label'
                      id='title_id'
                      name='title_id'
                      disabled={props.role === 'detail' ? true : false}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.title_id}
                      label='Jenis Kategori'
                    >
                      {titleOptions
                        ? titleOptions.map((item, key) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name + ' TAHUN ' + item.year}
                              </MenuItem>
                            );
                          })
                        : ''}
                    </Select>
                  </FormControl>
                  {formik.touched.title_id && formik.errors.title_id ? (
                    <ErrorText>{formik.errors.title_id}</ErrorText>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label='Nama'
                    id='display_name'
                    onClick={() => handleToggleAddressBook('Name')}
                    fullWidth
                    disabled={props.role === 'detail' ? true : false}
                    InputProps={{
                      readOnly: true,
                    }}
                    required
                    name='display_name'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.display_name}
                  />
                  {formik.touched.display_name && formik.errors.display_name ? (
                    <ErrorText>{formik.errors.display_name}</ErrorText>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label='NIP'
                    id='profile_nip'
                    fullWidth
                    disabled
                    required
                    name='profile_nip'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.profile_nip}
                  />
                  {formik.touched.profile_nip && formik.errors.profile_nip ? (
                    <ErrorText>{formik.errors.profile_nip}</ErrorText>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    label='Unit Kerja'
                    id='unker'
                    fullWidth
                    disabled
                    required
                    name='unker'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.unker}
                  />
                  {formik.touched.unker && formik.errors.unker ? (
                    <ErrorText>{formik.errors.unker}</ErrorText>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label='Satuan Kerja'
                    id='satker'
                    fullWidth
                    disabled
                    required
                    name='satker'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.satker}
                  />
                  {formik.touched.satker && formik.errors.satker ? (
                    <ErrorText>{formik.errors.satker}</ErrorText>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label='Coach'
                    id='display_coach'
                    onClick={() => handleToggleAddressBook('Coach')}
                    fullWidth
                    disabled={props.role === 'detail' ? true : false}
                    name='display_coach'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.display_coach}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth>
                    <InputLabel id='demo-simple-select-label'>
                      Peringkat
                    </InputLabel>
                    <Select
                      required
                      labelId='demo-simple-select-label'
                      id='order'
                      name='order'
                      disabled={props.role === 'detail' ? true : false}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.order}
                      label='Peringkat'
                    >
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3} alignSelf={'center'}>
                  <Typography fontWeight={'bold'}>Implementasi</Typography>{' '}
                </Grid>
                <Grid item xs={12} md={1} alignSelf={'center'}>
                  :
                </Grid>

                <Grid item xs={12} md={8} alignSelf={'center'}>
                  <RadioGroup
                    sx={{flexDirection: 'row', alignItems: 'center'}}
                    name='implementation'
                    value={formik.values.implementation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <FormControlLabel
                      value='true'
                      control={
                        <Radio
                          disabled={
                            props.role === 'detail' || props.role === 'add'
                              ? true
                              : false
                          }
                        />
                      }
                      label='Ya'
                    />
                    <FormControlLabel
                      value='false'
                      control={
                        <Radio
                          disabled={
                            props.role === 'detail' || props.role === 'add'
                              ? true
                              : false
                          }
                        />
                      }
                      label='Tidak'
                    />
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label='Manfaat'
                    id='benefit'
                    fullWidth
                    disabled={props.role === 'detail' ? true : false}
                    name='benefit'
                    multiline
                    rows={3}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.benefit}
                  />
                </Grid>
                <Grid item xs={12} md={3} alignSelf={'center'}>
                  <Typography fontWeight={'bold'}>Rating</Typography>{' '}
                </Grid>
                <Grid item xs={12} md={1} alignSelf={'center'}>
                  :
                </Grid>
                <Grid item xs={12} md={8} alignSelf={'center'}>
                  <Rating
                    id='rating'
                    name='rating'
                    onChange={formik.handleChange}
                    disabled={props.role === 'detail' ? true : false}
                    value={formik.values.rating}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label='Catatan'
                    id='note'
                    fullWidth
                    disabled={props.role === 'detail' ? true : false}
                    name='note'
                    multiline
                    rows={3}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.note}
                  />
                </Grid>
                <Grid item xs={12} md={12} alignSelf={'center'}>
                  <Typography marginBottom={'1rem'} fontWeight={'bold'}>
                    {props.role === 'detail' ? 'File' : 'Upload File'}
                  </Typography>
                  {isFileExistError && !props.uploadedFiles ? (
                    <ErrorText sx={{marginTop: 5, marginBottom: 2}}>
                      Mohon Lampirkan File!
                    </ErrorText>
                  ) : null}
                  {props.uploadedFiles ? (
                    <FileRow
                      key={props.uploadedFiles.name}
                      file={props.uploadedFiles}
                      isDisabled={props.role === 'detail' ? true : false}
                      onDeleteUploadFile={onDeleteUploadFile}
                    />
                  ) : (
                    <UploadAksi
                      uploadText='Seret dan jatuhkan unggah file  dalam format pdf di sini, atau klik untuk memilih file'
                      getRootProps={getRootProps({className: 'dropzone'})}
                      getInputProps={getInputProps()}
                      height='265px'
                    />
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </Box>
        <Addressbook
          stateAddress={stateAddress}
          toggleHide={toggleHide}
          setPayloadOnHide={setPayloadOnHide}
          config={config}
        />
      </form>
    </>
  );
});

export default DialogForm;

DialogForm.propTypes = {
  detailData: PropTypes.any,
  role: PropTypes.string,
  uploadedFiles: PropTypes.any,
  setUploadedFiles: PropTypes.func,
};
